import { useRef, useState } from 'react';
import NoSleep from 'nosleep.js';
import { useNavigation } from '@/navigation/NavigationContex.ts';

type TimerState = 'running' | 'reset' | 'finished';

export const useCountdown = (timerDuration: number) => {
  const { setSlideValid } = useNavigation();
  const [secsRemaining, setSecsRemaining] = useState<number>(timerDuration);
  const [timerState, setTimerState] = useState<TimerState>('reset');
  const intervalHandle = useRef<ReturnType<typeof setInterval>>(undefined);
  const noSleep = new NoSleep();

  const startCountdown = () => {
    setSecsRemaining(timerDuration);
    setTimerState('running');

    noSleep.enable().catch((e) => {
      console.log(e);
      console.log('Nosleep needs "Wake Lock" permissions on mobile devices. The user chose not to grant them.');
    });

    intervalHandle.current = setInterval(() => {
      setSecsRemaining((prev) => {
        const newRemaining = prev - 1 > 0 ? prev - 1 : 0;
        if (newRemaining === 0) {
          finishCountdown();
        }
        return newRemaining;
      });
    }, 1000);
  };

  const finishCountdown = () => {
    setTimerState('finished');
    setSlideValid(true);
    clearInterval(intervalHandle.current);
  };

  const resetCountdown = () => {
    setTimerState('reset');
    setSecsRemaining(timerDuration);
    clearInterval(intervalHandle.current);
  };

  return {
    startCountdown,
    resetCountdown,
    timerState,
    secsRemaining,
  };
};
